<template>
  <div class="home">

    <div class="fullScreen" v-if="fullScreen">
      <button class="close" @click="closeFullScreen">
        <font-awesome-icon icon="times"/>
      </button>
    </div>

    <Nav @login="onLogin" @singup="onSingup"/>
    <LoginBox v-if="login" @close="login = false" @resetPassword="onResetPassword"/>
    <SingupBox v-if="singup" @close="singup = false" :promoCode="promo_code"/>
    <ResetPasswordBox v-if="resetPassword" :copiedEmail="resetEmail" @close="resetPassword = false"/>
    <div class="body">
      <div class="limiter">
        <div class="first-row">
          <div class="content-limiter">

            <div class="content-box">

              <div class="title-box">Make speaking assignments fun</div>
              <div class="sides-box">

                <div class="left-side">
                  <div class="label-box">Teacher</div>
                  <div class="list-box">
                    <div class="list-item">> choose or create interactive scenes</div>
                    <div class="list-item">> assign to students</div>
                    <div class="list-item">> assess students' performance</div>
                  </div>
                  <div class="button-box">
                    <button @click="onSingup">Free account >></button>
                  </div>
                </div>
                <div class="right-side">
                  <div class="label-box">Student</div>
                  <div class="list-box">
                    <div class="list-item">> explore communication patterns</div>
                    <div class="list-item">> practise speaking</div>
                    <div class="list-item">> record and share recordings</div>
                  </div>
                  <div class="button-box">
                    <button @click="scrollToExamples">See examples >></button>
                  </div>
                </div>

              </div>

            </div>

            <div class="images-box">
              <ImageSlider/>
            </div>

          </div>
        </div>

        <div class="dialog-row-right">
          <div class="content-limiter">
            <div class="content-box">
              <div class="title-box">Meet Frogero</div>
              <div class="subtitle-box">Get to know a polyglot frog who encourages others to speak.</div>
            </div>
            <div class="iframe-box">
              <div class="loading-box">
                <Loader color="white"/>
              </div>
              <iframe class="iframe_1" :src="getLink('5f53247ed65bb9001752482b')"></iframe>
              <button class="full-screen-trigger" @click="openFullScreen('iframe_1')" v-if="!fullScreen" title="Fullscreen">
                <font-awesome-icon icon="expand"/>
              </button>
              <button class="copy-button" v-if="!fullScreen && TokenState" title="Pin" @click="onPin('5f53247ed65bb9001752482b')">
                <font-awesome-icon icon="thumbtack"/>
              </button>
            </div>
          </div>
        </div>

        <div class="dialog-row-left">
          <div class="content-limiter">
            <div class="iframe-box">
              <div class="loading-box">
                <Loader color="white"/>
              </div>
              <iframe class="iframe_2" :src="getLink('5f536882d5f37d0017433e06')"></iframe>
              <button class="full-screen-trigger" @click="openFullScreen('iframe_2')" v-if="!fullScreen" title="Fullscreen">
                <font-awesome-icon icon="expand"/>
              </button>
              <button class="copy-button" v-if="!fullScreen && TokenState" title="Pin" @click="onPin('5f536882d5f37d0017433e06')">
                <font-awesome-icon icon="thumbtack"/>
              </button>
            </div>
            <div class="content-box">
              <div class="title-box">5 things about your favourite film</div>
              <div class="subtitle-box">Show students a model and structure for their speech.</div>
            </div>
          </div>
        </div>

        <div class="dialog-row-right">
          <div class="content-limiter">
            <div class="content-box">
              <div class="title-box">Where did you go for your last holiday?</div>
              <div class="subtitle-box">Real live small talk vocabulary and phrasebook example.</div>
            </div>
            <div class="iframe-box">
              <div class="loading-box">
                <Loader color="white"/>
              </div>
              <iframe class="iframe_3" :src="getLink('605c82b96c9a1a001735abb8')"></iframe>
              <button class="full-screen-trigger" @click="openFullScreen('iframe_3')" v-if="!fullScreen" title="Fullscreen">
                <font-awesome-icon icon="expand"/>
              </button>
              <button class="copy-button" v-if="!fullScreen && TokenState" title="Pin" @click="onPin('605c82b96c9a1a001735abb8')">
                <font-awesome-icon icon="thumbtack"/>
              </button>
            </div>
          </div>
        </div>

        <div class="dialog-row-left">
          <div class="content-limiter">
            <div class="iframe-box">
              <div class="loading-box">
                <Loader color="white"/>
              </div>
              <iframe class="iframe_4" :src="getLink('5f533f17d65bb9001752482e')"></iframe>
              <button class="full-screen-trigger" @click="openFullScreen('iframe_4')" v-if="!fullScreen" title="Fullscreen">
                <font-awesome-icon icon="expand"/>
              </button>
              <button class="copy-button" v-if="!fullScreen && TokenState" title="Pin" @click="onPin('5f533f17d65bb9001752482e')">
                <font-awesome-icon icon="thumbtack"/>
              </button>
            </div>
            <div class="content-box">
              <div class="title-box">Describing a picture: vegetables</div>
              <div class="subtitle-box">Practise one of most frequent examination assignments.</div>
            </div>
          </div>
        </div>

        <div class="dialog-row-right">
          <div class="content-limiter">
            <div class="content-box">
              <div class="title-box">Job interview</div>
              <div class="subtitle-box">Interactive guide through typical job interview questions and best answers.</div>
            </div>
            <div class="iframe-box">
              <div class="loading-box">
                <Loader color="white"/>
              </div>
              <iframe class="iframe_5" :src="getLink('5f532cc8d65bb9001752482d')"></iframe>
              <button class="full-screen-trigger" @click="openFullScreen('iframe_5')" v-if="!fullScreen" title="Fullscreen">
                <font-awesome-icon icon="expand"/>
              </button>
              <button class="copy-button" v-if="!fullScreen && TokenState" title="Pin" @click="onPin('5f532cc8d65bb9001752482d')">
                <font-awesome-icon icon="thumbtack"/>
              </button>
            </div>
          </div>
        </div>

      </div>
      <footer>
        <router-link to="/terms-of-use">
          <span class="terms">Terms of use</span>
        </router-link>
        <router-link to="/privacy-and-data-notice">
          <span class="privacy">Privacy and data notice</span>
        </router-link>
        <span class="copyright">Copyright © 2020 Frogero.com</span>
      </footer>
    </div>
  </div>
</template>

<script>
import alert from '@/lib/alert'
import axios from 'axios'
import Nav from '@/components/Home/Nav'
import LoginBox from '../components/Home/LoginBox'
import SingupBox from '../components/Home/SingupBox'
import ImageSlider from '../components/Home/ImageSlider'
import ResetPasswordBox from '../components/Home/ResetPasswordBox'
import Loader from '@/components/Loader'

export default {
  name: 'Home',
  data() {
    return {
      login: false,
      singup: false,
      resetPassword: false,
      resetEmail: null,
      fullScreen: false,
      currentIframe: null,
      promo_code: null
    }
  },
  components: {
    Nav,
    LoginBox,
    SingupBox,
    ImageSlider,
    ResetPasswordBox,
    Loader
  },
  methods: {
    // ...mapActions('alerts', ['setError', 'setSuccess']),
    onLogin() {
      this.singup = false;
      this.login = true;
    },
    onSingup() {
      this.login = false;
      this.singup = true;
    },
    openFullScreen(iframeClass) {
      let iframe = document.querySelector(`.${iframeClass}`);
      this.fullScreen = true;
      this.currentIframe = iframeClass;
      iframe.classList.add('full-screen-mode');
    },
    closeFullScreen() {
      let iframe = document.querySelector(`.${this.currentIframe}`);
      this.fullScreen = false;
      iframe.classList.remove('full-screen-mode');
      this.currentIframe = null;
    },
    // onCopy(sourceId) {
    //   console.log('Copy');
    //   axios({
    //     method: 'post',
    //     url: `${process.env.VUE_APP_SERVER_URL}limitDialogs`,
    //     headers: {
    //       Authorization: 'Bearer ' + localStorage.getItem('token') 
    //     },
    //   }).then(() => {
    //     axios({
    //       method: 'post',
    //       url: `${process.env.VUE_APP_SERVER_URL}copyDialog`,
    //       headers: {
    //         Authorization: 'Bearer ' + localStorage.getItem('token') 
    //       },
    //       data: {
    //         sourceId
    //       }
    //     }).then(() => {
    //       console.log('Copy Created');
    //       alert.showSuccess('Copy Created');
    //       this.$router.push('/main');
    //     }).catch(() => {
    //       console.log('Clonning Error');
    //       alert.showError('Clonning Error');
    //     })
    //   }).catch(() => {
    //     console.log('Limit Error');
    //     alert.showError('Dialog limit reached');
    //   })
    // },
    onPin(sourceId) {
      console.log('Pin');
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}addPin`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          exerciseId: sourceId,
        }
      }).then(() => {
        console.log('Pin Created');
        alert.showSuccess('Pin Created');
        this.$router.push('/main');
      }).catch(() => {
        console.log('Pin Creating Error');
        alert.showError('Pin Creating Error');
      })
    },
    scrollToExamples() {
      let element = document.querySelector('.dialog-row-right');
      element.scrollIntoView();
    },
    getLink(exercise_id) {
      return `${window.location.origin}/hub?exercise_id=${exercise_id}`;
    },
    onResetPassword(email) {
      this.resetEmail = email;
      this.login = false;
      this.resetPassword = true;
    }
  },
  computed: {
    TokenState() {
      if(localStorage.getItem('token') != null) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const action = urlParams.get('action');
    const promo_code = urlParams.get('promo_code');

    if(action == 'login') {
      this.onLogin();
    }
    if(action == 'register') {
      this.promo_code = promo_code;
      this.onSingup();
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  min-height: 100vh;
  background-color: whitesmoke;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

.fullScreen {
  width: 100%;
  height: 100vh;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.795);
  z-index: 9;

  button {
    width: 2rem;
    height: 2rem;
    position: absolute;
    right: 3rem;
    top: 2rem;
    font-size: 2rem;
    color: white;
    background: none;
    outline: none;
    border: none;
    transition: 0.3s;
    z-index: 10;

    @media (max-width: 1000px) {
      right: 1rem;
      top: 0.5rem;
    }

    &:hover {
      cursor: pointer;
      color: rgb(219, 218, 218);
    }
  }
}

.body {
  width: 100%;
  flex: auto;
  display: flex;
  background-color: #0f978a;
  flex-direction: column;
  align-items: center;
  // padding-bottom: 4rem;
}

footer {
  width: 100%;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;

  a {
    text-decoration: none;
    color: white;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    height: 6rem;
    justify-content: space-evenly;
  }

  .terms {
    transition: 0.2s;
    &:hover {
      color: #ebc659;
      cursor: pointer;
    }
  }

  .privacy {
    margin-left: 3rem;
    transition: 0.2s;
    &:hover {
      color: #ebc659;
      cursor: pointer;
    }
    @media (max-width: 600px) {
      margin-left: unset;
    }
  }

  .copyright {
    margin-left: 3rem;
    transition: 0.2s;
    @media (max-width: 600px) {
      margin-left: unset;
    }
  }
}

.limiter {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

.first-row {
  width: 100%;
  height: 26rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #006C6F;
  @media (max-width: 900px) {
    height: 55rem;
  }
  @media (max-width: 700px) {
    height: auto;
    padding-bottom: 2rem;
  }

  .content-limiter {
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: row;

    @media (max-width: 1200px) {
      width: 90%;
    }
    @media (max-width: 1050px) {
      width: 95%;
    }
    @media (max-width: 900px) {
      width: 80%;
      flex-direction: column;
    }
    @media (max-width: 600px) {
      width: 90%;
    }
  }

  .content-box {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    @media (max-width: 900px) {
      width: 100%;
    }

    .title-box {
      width: 100%;
      height: 5rem;
      margin-top: 2rem;
      display: flex;
      align-items: center;
      color: white;
      font-size: 2rem;
      font-weight: bold;
      @media (max-width: 1200px) {
        font-size: 1.8rem;
      }
      @media (max-width: 600px) {
        font-size: 1.4rem;
      }
    }

    .sides-box {
      width: 100%;
      height: 19rem;
      display: flex;
      flex-direction: row;
      @media (max-width: 700px) {
        flex-direction: column;
        height: 38rem;
        align-items: center;
      }
      @media (max-width: 600px) {
        height: auto;
      }

      .left-side {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        @media (max-width: 700px) {
          width: 80%;
        }
        @media (max-width: 600px) {
          width: 100%;
        }

        button {
          background-color: #e6c17d;
          transition: 0.3s;

          &:hover {
            cursor: pointer;
            background-color: #cfae71;
          }
        }
      }

      .right-side {
        width: 50%;
        height: 100%;
        display: flex;
        flex-direction: column;
        @media (max-width: 700px) {
          width: 80%;
        }
        @media (max-width: 600px) {
          width: 100%;
        }

        button {
          background-color: #34BDA9;
          transition: 0.3s;

          &:hover {
            cursor: pointer;
            background-color: #30a795;
          }
        }
      }

      .label-box {
        width: 100%;
        height: 3rem;
        display: flex;
        align-items: center;
        color: #12BCAA;
        font-weight: bold;
        font-size: 1.3rem;
      }

      .list-box{
        width: 100%;
        height: 11rem;
        display: flex;
        flex-direction: column;
        @media (max-width: 600px) {
          height: auto;
        }

        .list-item {
          width: 90%;
          height: auto;
          font-size: 1.2rem;
          color: white;
          margin-bottom: 1rem;
          @media (max-width: 600px) {
            margin-top: 1rem;
          }
        }
      }

      .button-box {
        width: 100%;
        height: 5rem;
        display: flex;
        align-items: flex-start;
        @media (max-width: 600px) {
          height: 6rem;
          align-items: center;
        }

        button {
          width: 12rem;
          height: 3rem;
          border: none;
          outline: none;
          color: white;
          font-size: 1.2rem;
          border-radius: 0.3rem;
        }
      }
    }
  }

  .images-box {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 900px) {
      width: 100%;
    }
  }
}

.dialog-row-right {
  width: 100%;
  height: 26rem;
  background-color: white;
  display: flex;
  justify-content: center;

  @media (max-width: 900px) {
    height: auto;
    padding-bottom: 2rem;
  }

  .content-limiter {
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: row;

    @media (max-width: 1200px) {
      width: 90%;
    }
    @media (max-width: 1050px) {
      width: 95%;
    }
    @media (max-width: 900px) {
      width: 80%;
      flex-direction: column;
    }
    @media (max-width: 600px) {
      width: 90%;
    }
  }

  .content-box {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (max-width: 900px) {
      height: 20rem;
      width: 100%;
    }

    .title-box {
      width: 100%;
      height: 4rem;
      display: flex;
      align-items: center;
      font-size: 1.8rem;
      color: #11b6a5;
    }

    .subtitle-box {
      width: 80%;
      height: 4rem;
      display: flex;
      align-items: center;
      font-size: 1.4rem;
      color: #11b6a5;
      @media (max-width: 900px) {
        height: auto;
        width: 90%;
        margin-top: 1rem;
      }
    }
  }

  .iframe-box {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    @media (max-width: 900px) {
      height: 90vh;
      width: 100%;
    }

    .loading-box {
      width: 90%;
      height: 90%;
      background-color: rgb(202, 202, 202);
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.3rem;
    }

    iframe {
      min-width: 180%;
      min-height: 180%;
      border: none;
      border-radius: 0.3rem;
      transform: scale(0.5);
      z-index: 1;

      @media (max-width: 900px) {
        min-width: 100%;
        min-height: 100%;
        transform: scale(0.9);
      }

      @media (max-width: 800px) {
        min-width: 100%;
        min-height: 100%;
        transform: scale(1);
      }

      @media (max-width: 600px) {
        min-width: 110%;
        min-height: 110%;
        transform: scale(0.9);
      }
    }

    .full-screen-mode {
      position: fixed;
      z-index: 9;
      width: 80vw;
      min-width: unset;
      max-width: 1920px;
      height: 90vh;
      min-height: unset;
      max-height: 1080px;
      transform: unset;
      left: 10vw;
      top: 5vh;

      @media (max-width: 1000px) {
        width: 90vw;
        left: 5vw;
      }
    }

    .full-screen-trigger {
      width: 2.5rem;
      height: 2.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.2rem;
      background-color: rgb(255, 255, 255);
      border-radius: 0.3rem;
      border: none;
      outline: none;
      z-index: 2;
      position: absolute;
      bottom: 7%;
      right: 6.5%;
      transition: 0.3s;

      @media (max-width: 900px) {
        display: none;
      }

      &:hover {
        cursor: pointer;
        background-color: rgb(218, 218, 218);
      }
    }

    .copy-button {
      width: 2.5rem;
      height: 2.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.2rem;
      background-color: rgb(255, 255, 255);
      border-radius: 0.3rem;
      border: none;
      outline: none;
      z-index: 2;
      position: absolute;
      bottom: 7%;
      right: calc(6.5% + 3.5rem);
      transition: 0.3s;

      @media (max-width: 900px) {
        right: 8%;
      }
      @media (max-width: 800px) {
        right: 3%;
        bottom: 2%;
      }

      &:hover {
        cursor: pointer;
        background-color: rgb(218, 218, 218);
      }
    }

  }
}

.dialog-row-left {
  width: 100%;
  height: 26rem;
  background-color: white;
  display: flex;
  justify-content: center;

  @media (max-width: 900px) {
    height: auto;
    padding-bottom: 2rem;
  }

  .content-limiter {
    width: 80%;
    height: 100%;
    display: flex;
    flex-direction: row;

    @media (max-width: 1200px) {
      width: 90%;
    }
    @media (max-width: 1050px) {
      width: 95%;
    }
    @media (max-width: 900px) {
      width: 80%;
      flex-direction: column-reverse;
    }
    @media (max-width: 600px) {
      width: 90%;
    }
  }

  .content-box {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;

    @media (max-width: 900px) {
      height: 20rem;
      width: 100%;
      align-items: flex-start;
    }

    .title-box {
      width: 100%;
      height: 4rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 1.8rem;
      color: #11b6a5;

      @media (max-width: 900px) {
        justify-content: flex-start;
      }
    }

    .subtitle-box {
      width: 80%;
      height: 4rem;
      display: flex;
      align-items: center;
      text-align: right;
      justify-content: flex-end;
      font-size: 1.4rem;
      color: #11b6a5;
      @media (max-width: 900px) {
        height: auto;
        width: 90%;
        justify-content: flex-start;
        text-align: left;
        margin-top: 1rem;
      }
    }
  }

  .iframe-box {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    @media (max-width: 900px) {
      height: 90vh;
      width: 100%;
    }

    .loading-box {
      width: 90%;
      height: 90%;
      background-color: rgb(202, 202, 202);
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.3rem;
    }

    iframe {
      min-width: 180%;
      min-height: 180%;
      border: none;
      border-radius: 0.3rem;
      transform: scale(0.5);
      z-index: 1;

      @media (max-width: 900px) {
        min-width: 100%;
        min-height: 100%;
        transform: scale(0.9);
      }

      @media (max-width: 800px) {
        min-width: 100%;
        min-height: 100%;
        transform: scale(1);
      }

      @media (max-width: 600px) {
        min-width: 110%;
        min-height: 110%;
        transform: scale(0.9);
      }
    }

    .full-screen-mode {
      position: fixed;
      z-index: 9;
      width: 80vw;
      min-width: unset;
      max-width: 1920px;
      height: 90vh;
      min-height: unset;
      max-height: 1080px;
      transform: unset;
      left: 10vw;
      top: 5vh;

      @media (max-width: 1000px) {
        width: 90vw;
        left: 5vw;
      }
    }

    .full-screen-trigger {
      width: 2.5rem;
      height: 2.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.2rem;
      background-color: rgb(255, 255, 255);
      border-radius: 0.3rem;
      border: none;
      outline: none;
      z-index: 2;
      position: absolute;
      bottom: 7%;
      right: 6.5%;
      transition: 0.3s;

      @media (max-width: 900px) {
        display: none;
      }

      &:hover {
        cursor: pointer;
        background-color: rgb(218, 218, 218);
      }
    }

    .copy-button {
      width: 2.5rem;
      height: 2.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.2rem;
      background-color: rgb(255, 255, 255);
      border-radius: 0.3rem;
      border: none;
      outline: none;
      z-index: 2;
      position: absolute;
      bottom: 7%;
      right: calc(6.5% + 3.5rem);
      transition: 0.3s;

      @media (max-width: 900px) {
        right: 8%;
      }
      @media (max-width: 800px) {
        right: 3%;
        bottom: 2%;
      }

      &:hover {
        cursor: pointer;
        background-color: rgb(218, 218, 218);
      }
    }

  }
}

//Loading Box Animation
.lds-dual-ring {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 100px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>